const validate = (values) => {
  const errors = {};

  // Validate invoiceNumber
  if (!values.tourDate) {
    errors.tourDate = "Required";
  }
  if (!values.invoiceNumber) {
    errors.invoiceNumber = "Required";
  }
  if (!values.customerName) {
    errors.customerName = "Required";
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = "Required";
  }

  // Validate tourItenaryList
  if (values.tourItenaryList && values.tourItenaryList.length) {
    errors.tourItenaryList = values.tourItenaryList.map((item, index) => {
      const itemErrors = {};

      // Validate pickupLocation
      if (!item || !item.travelDate) {
        itemErrors.travelDate = "Required";
      }
      if (!item || !item.service) {
        itemErrors.service = "Required";
      }
      if (!item || !item.vehicleId) {
        itemErrors.vehicleId = "Required";
      }
      if (!item || !item.hotelName) {
        itemErrors.hotelName = "Required";
      }

      // Validate AttractionItenery
      if (item && item.tourAttractionList && item.tourAttractionList.length) {
        itemErrors.tourAttractionList = item.tourAttractionList.map(
          (attraction, attArrindex) => {
            const attractionErrors = {};

            // Validate quantity
            if (!attraction || !attraction.attractionId) {
              attractionErrors.attractionId = "Required";
            }
            if (!attraction || !attraction.quantity) {
              attractionErrors.quantity = "Required";
            }
            if (!attraction || !attraction.guideName) {
              attractionErrors.guideName = "Required";
            }

            // Add other validations for AttractionItenery fields as needed

            return attractionErrors;
          }
        );
      }

      return itemErrors;
    });
  }

  return errors;
};

export default validate;
